import { useState } from "react";
import { Flag, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { errMsg, http } from "@/lib/api";

const REASONS = ["Outdated price list", "File won't open", "Wrong brand or category", "Other problem"];
const field = "mt-1.5 w-full rounded-2xl border border-ph-line bg-ph-bg px-4 py-3 text-sm text-ph-ink outline-none focus:border-ph-accent/60";

export function ReportDocButton({ doc }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(REASONS[0]);
  const [note, setNote] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post(`/documents/${doc.id}/report`, { reason, note, email });
      toast.success("Thanks, report sent", { description: "The PRICEHUB team will check this document." });
      setOpen(false);
      setNote("");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={`report-doc-btn-${doc.id}`}
        className="inline-flex min-h-[40px] items-center gap-1.5 rounded-full px-3 text-xs font-medium text-ph-muted transition-colors hover:bg-ph-raised hover:text-ph-ink">
        <Flag className="h-3.5 w-3.5" /> Report a problem
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md rounded-3xl" data-testid="report-doc-dialog">
          <DialogTitle className="font-display text-xl font-bold text-ph-ink">Report this price list</DialogTitle>
          <DialogDescription className="text-sm text-ph-muted">{doc.brand_name} — {doc.title}</DialogDescription>
          <form onSubmit={submit} className="space-y-4">
            <label className="block text-sm font-medium text-ph-ink">What's wrong?
              <select value={reason} onChange={(e) => setReason(e.target.value)} data-testid="report-reason-select" className={field}>
                {REASONS.map((r) => <option key={r}>{r}</option>)}
              </select>
            </label>
            <label className="block text-sm font-medium text-ph-ink">Details (optional)
              <textarea value={note} onChange={(e) => setNote(e.target.value)} maxLength={600} rows={3} data-testid="report-note-input" className={field} />
            </label>
            <label className="block text-sm font-medium text-ph-ink">Your email, if you'd like a reply (optional)
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="report-email-input" className={field} />
            </label>
            <button type="submit" disabled={busy} data-testid="report-submit-btn" className="flex h-11 w-full items-center justify-center gap-2 rounded-full bg-ph-lime text-sm font-semibold text-ph-navy disabled:opacity-60">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Send report
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
